package io.horion.cv.pages.cv

import com.varabyte.kobweb.compose.foundation.layout.Column
import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.css.overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.left
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.top
import com.varabyte.kobweb.compose.ui.modifiers.whiteSpace
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronLeft
import com.varabyte.kobweb.silk.components.icons.fa.FaChevronRight
import com.varabyte.kobweb.silk.components.icons.fa.FaCloud
import com.varabyte.kobweb.silk.components.icons.fa.FaHouse
import com.varabyte.kobweb.silk.components.icons.fa.FaMoon
import com.varabyte.kobweb.silk.components.icons.fa.FaSun
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import io.horion.cv.viewModel.CvViewModel
import io.horion.cv.api.datasource.cv.Model
import io.horion.cv.di.koinGet
import io.horion.cv.models.CvData.cvList
import io.horion.cv.pages.navigation.Screen
import io.horion.cv.state.AppState
import io.horion.cv.styles.ChevronButtonIconStyle
import io.horion.cv.styles.ChooseCvDesktopContainerStyle
import io.horion.cv.styles.ChooseCvMobileContainerStyle
import io.horion.cv.styles.ChooseCvSubtitleStyle
import io.horion.cv.styles.ChooseCvTitleStyle
import io.horion.cv.styles.ChooseModelStyle
import io.horion.cv.styles.HeaderHomeIconStyle
import io.horion.cv.styles.HeaderHomeMarginStyle
import io.horion.cv.styles.HeaderHomeTextStyle
import io.horion.cv.styles.HeaderPaddingStyle
import io.horion.cv.styles.HeaderThemeContainerStyle
import io.horion.cv.styles.HeaderThemeIconStyle
import io.horion.cv.styles.HeaderTitleContainerStyle
import io.horion.cv.styles.HeaderTitleIconStyle
import io.horion.cv.styles.HeaderTitleTextStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import kotlinx.browser.window
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px

@Page("/choose-cv")
@Composable
fun ChooseCvPage() {
    val ctx = rememberPageContext()
    var page by remember { mutableStateOf(0) }
    val cvViewModel = koinGet<CvViewModel>()

    val models = cvList
    val totalPages = models.size
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    val pageBg = if (isDark) Colors.DarkBG else Colors.White
    val textColor = if (isDark) Colors.White else Colors.Primary

    val cardWidth = 340
    val cardGap = 20

    Column(
        modifier = Modifier
            .fillMaxSize()
            .backgroundColor(pageBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
    ) {
        HeaderBar()

        // Disposition Mobile
        Column(
            modifier = ChooseCvMobileContainerStyle.toModifier(),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                "Choisissez\nVotre modèle",
                modifier = ChooseCvTitleStyle.toModifier()
                    .color(textColor)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .whiteSpace(WhiteSpace.PreWrap)
                    .styleModifier { property("text-align", "center") }
            )

            SpanText(
                "Cliquez sur le modèle qui correspond\nà vos centres d'intérêts pour continuer",
                modifier = ChooseCvSubtitleStyle.toModifier()
                    .color(textColor)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Light)
                    .whiteSpace(WhiteSpace.PreWrap)
                    .styleModifier { property("text-align", "center") }
            )

            Box(
                modifier = Modifier
                    .width(320.px)
                    .height(470.px)
                    .position(Position.Relative)
                    .styleModifier { overflow(Overflow.Hidden) }
            ) {
                Row(
                    modifier = Modifier
                        .height(470.px)
                        .width(((320 + 12) * cvList.size).px)
                        .styleModifier {
                            property("transform", "translateX(-${page * (320 + 12)}px)")
                            property("transition", "transform 400ms ease")
                        }
                ) {
                    cvList.forEach { model ->
                        Box(
                            modifier = Modifier
                                .width(320.px)
                                .height(470.px)
                                .margin(right = 12.px)
                        ) {
                            CvCards(
                                src = model.value,
                                onClick = {
                                    Model.entries
                                        .firstOrNull { it.name == model.key }
                                        ?.let { cvViewModel.updateModel(it) }
                                    ctx.router.navigateTo("/info_pers")
                                }
                            )
                        }
                    }
                }

                if (page > 0) {
                    ChevronButtons(left = true) { page-- }
                }
                ChevronButtons(left = false) {
                    page = (page + 1) % totalPages
                }
            }
        }

        // Disposition Desktop Centrée
        Box(
            modifier = ChooseCvDesktopContainerStyle.toModifier()
                .backgroundColor(pageBg),
            contentAlignment = Alignment.Center
        ) {
            Row(
                modifier = Modifier.fillMaxWidth(),
                horizontalArrangement = Arrangement.SpaceEvenly,
                verticalAlignment = Alignment.CenterVertically
            ) {
                // Colonne Texte (Gauche)
                Column(
                    horizontalAlignment = Alignment.Start
                ) {
                    SpanText(
                        "Choisissez\nVotre modèle",
                        modifier = ChooseCvTitleStyle.toModifier()
                            .color(textColor)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Bold)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )

                    Box(Modifier.height(16.px))

                    SpanText(
                        "Cliquez sur le modèle qui correspond\nà vos centres d'intérêts pour continuer",
                        modifier = ChooseCvSubtitleStyle.toModifier()
                            .color(textColor)
                            .fontFamily(INTER)
                            .fontWeight(FontWeight.Light)
                            .whiteSpace(WhiteSpace.PreWrap)
                    )
                }

                // Zone Carrousel (Droite)
                Box(
                    modifier = Modifier
                        .width(cardWidth.px)
                        .height(500.px)
                        .position(Position.Relative)
                        .styleModifier { overflow(Overflow.Hidden) }
                ) {
                    Row(
                        modifier = Modifier
                            .height(500.px)
                            .width(((cardWidth + cardGap) * cvList.size).px)
                            .styleModifier {
                                property("transform", "translateX(-${page * (cardWidth + cardGap)}px)")
                                property("transition", "transform 400ms ease")
                            }
                    ) {
                        cvList.forEach { model ->
                            Box(
                                modifier = Modifier
                                    .width(cardWidth.px)
                                    .height(500.px)
                                    .margin(right = cardGap.px)
                            ) {
                                CvCards(
                                    src = model.value,
                                    onClick = {
                                        Model.entries
                                            .firstOrNull { it.name == model.key }
                                            ?.let { cvViewModel.updateModel(it) }
                                        ctx.router.navigateTo("/info_pers")
                                    }
                                )
                            }
                        }
                    }

                    if (page > 0) {
                        ChevronButtons(left = true) { page-- }
                    }

                    ChevronButtons(left = false) {
                        page = (page + 1) % totalPages
                    }
                }
            }
        }
    }
}

@Composable
fun HeaderBar(
    modifier: Modifier = Modifier
) {
    var colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val headerBg = if (isDark) Colors.DarkBG else Colors.White
    val borderColor = if (isDark) Colors.DarkGray else Colors.LightGray
    val textColor = if (isDark) Colors.White else Colors.Primary
    val iconFilter = if (isDark) "invert(1)" else "none"

    Row(
        modifier = HeaderPaddingStyle.toModifier()
            .then(modifier)
            .fillMaxWidth()
            .backgroundColor(headerBg)
            .styleModifier { property("transition", "background-color 300ms ease") }
            .borderBottom(1.px, LineStyle.Solid, borderColor)
            .textDecorationLine(TextDecorationLine.None),
        verticalAlignment = Alignment.CenterVertically,
        horizontalArrangement = Arrangement.SpaceBetween
    ) {
        Link(
            path = Screen.Home.path,
            modifier = Modifier
                .textDecorationLine(TextDecorationLine.None)
                .onClick {
                    window.history.back()
                }
        ) {
            Row(
                modifier = HeaderHomeMarginStyle.toModifier()
                    .cursor(Cursor.Pointer),
                verticalAlignment = Alignment.CenterVertically
            ) {
                FaHouse(
                    modifier = HeaderHomeIconStyle.toModifier()
                        .styleModifier { property("filter", iconFilter)}
                        .color(Colors.Black)
                )
                SpanText(
                    "Accueil",
                    modifier = HeaderHomeTextStyle.toModifier()
                        .margin(left = 10.px)
                        .fontFamily(INTER)
                        .color(textColor)
                )
            }
        }

        Row(
            modifier = HeaderTitleContainerStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            SpanText(
                "Choisissez votre modèle",
                modifier = HeaderTitleTextStyle.toModifier()
                    .margin(right = 10.px)
                    .fontFamily(INTER)
                    .fontWeight(FontWeight.Bold)
                    .color(textColor)
            )
//            Image(
//                src = "cloud-check.svg",
//                modifier = HeaderTitleIconStyle.toModifier()
//                    .styleModifier { property("filter", iconFilter) }
//            )
            FaCloud(
                modifier = HeaderTitleIconStyle.toModifier()
                    .styleModifier { property("filter", iconFilter) }
            )
        }

        Row(
            modifier = HeaderThemeContainerStyle.toModifier(),
            verticalAlignment = Alignment.CenterVertically
        ) {
            if (isDark) {
                FaSun(
                    modifier = HeaderThemeIconStyle.toModifier()
                        .color(Colors.yellow)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            } else {
                FaMoon(
                    modifier = HeaderThemeIconStyle.toModifier()
                        .color(Colors.Primary)
                        .cursor(Cursor.Pointer)
                        .onClick { colorMode = colorMode.opposite }
                )
            }
        }
    }
}

@Composable
fun ChevronButtons(
    left: Boolean,
    onClick: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark
    val iconFilter = "invert(1)"

    val chevronBg = if (isDark) Colors.Black.copy(alpha = 50) else Colors.Primary.copy(alpha = 80)

    Box(
        modifier = Modifier
            .size(40.px)
            .borderRadius(40.px)
            .backgroundColor(chevronBg)
            .cursor(Cursor.Pointer)
            .position(Position.Absolute)
            .top(50.percent)
            .styleModifier {
                property("transform", "translateY(-50%)")
                property("transition", "background-color 300ms ease")
            }
            .let {
                if (left) it.left(8.px) else it.right(8.px)
            }
            .onClick { onClick() },
        contentAlignment = Alignment.Center
    ) {
     /*   Image(
            src = if (left) "chevron-backward.svg" else "chevron-forward.svg",
            modifier = Modifier.size(24.px)
                .styleModifier {
                    property("filter", if (isDark) "none" else "invert(1)")
                }
        )*/

        if (left) {
            FaChevronLeft(
                modifier =  Modifier.fontSize(24.px)
                    .styleModifier { property("filter", iconFilter)},
//                size = IconSize.SM
            )

        } else {
            FaChevronRight(
                modifier =  Modifier.fontSize(24.px)
                    .styleModifier { property("filter", iconFilter)},
//                size = IconSize.SM
            )
        }
    }
}

@Composable
fun CvCards(
    src: String,
    onClick: () -> Unit
) {
    val colorMode by ColorMode.currentState
    val isDark = colorMode.isDark

    Box(
        modifier = ChooseModelStyle.toModifier()
            .cursor(Cursor.Pointer)
            .styleModifier {
                property("filter", if (isDark) "none" else "drop-shadow(0px 2px 8px rgba(0,0,0,0.15))")
                property("transition", "filter 300ms ease")
            }
            .onClick { onClick() }
    ) {
        Image(
            src = src,
            description = "CV",
            modifier = Modifier.fillMaxSize()
        )
    }
}